var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreviewForward(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 277"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 188",
    fill: "rgba(139,68,68,0)",
    d: "M0 0h23v23H0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "forward"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1555",
    d: "M13.388 1.193a.8.8 0 00-1.358.565v4.253c-4.3.171-6.456 1.956-6.785 2.253a12.087 12.087 0 00-4.19 7.025 12.384 12.384 0 00-.142 4.048c0 .012 0 .024.005.036l.169.974a.8.8 0 001.468.273l.507-.846a11.191 11.191 0 015.772-5.109 8.359 8.359 0 013.2-.469v4.405a.8.8 0 001.361.562l8.417-8.467a.8.8 0 000-1.127z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewForward);
export default __webpack_public_path__ + "static/media/preview_forward.ac50921a0c2b394fff682732404aa5bf.svg";
export { ForwardRef as ReactComponent };